import isEmpty from 'lodash.isempty'

/**
 * @param {string} collectionUrl - URL of the endpoint
 * @param {object} [config] - The configuration for building the query string
 * @param {number} [config.currentPage] - The page to get results for
 * @param {string[]} [config.filters] - The array of filters to apply
 * @param {number} [config.perPage] - The amount of results per page
 * @param {string} [config.query] - The query to add
 * @param {string} [config.search] - The string to search for
 * @param {object} [config.sorting] - Sorting for the request
 * @returns {string} - The query string built from the configuration
 */
export default function buildQueryString(collectionUrl, {
	currentPage = 1,
	filters = [],
	perPage = 10,
	query = '',
	search = '',
	sorting = { field: null, order: null }
} = {}) {
	if (typeof collectionUrl !== 'string') { throw new TypeError('url is not a string')}
	if (collectionUrl === '') { throw new Error('url is not filled in')}

	const segments = []

	if (perPage !== null && typeof perPage !== 'number') { throw new TypeError('perPage is not a number') }
	if (perPage) {
		segments.push(`paginate=${perPage}`)
	}

	if (currentPage !== null && typeof currentPage !== 'number') { throw new TypeError('currentPage is not a number') }
	if (currentPage) {
		segments.push(`page=${currentPage}`)
	}

	if (!(filters instanceof Array)) { throw new TypeError('filters is not an array') }
	if (!isEmpty(filters)) {
		segments.push(`filters=${filters.join('|')}`)
	}
	if (!isEmpty(sorting) && sorting.field !== null) {
		segments.push(`sort[${sorting.field}]=${sorting.order}`)
	}

	if (typeof search !== 'string') { throw new TypeError('search is not a string')}
	if (search) {
		segments.push(`search=${encodeURIComponent(search)}`)
	}

	if (typeof query !== 'string') { throw new TypeError('query is not a string')}
	const URLQuery = [ segments.join('&'), query ].join('')

	return [ collectionUrl, URLQuery ].filter(Boolean).join('?')
}
